<template>
  <div class="container" :data-testid="TEST_ID.GARANTIAS_REGISTRAR.ROOT">
    <div class="title" v-if="!guardado" :data-testid="TEST_ID.GARANTIAS_REGISTRAR.TITLE">
      {{ $t("GARANTIAS_registro_instalacion") }}
    </div>

    <div class="container_cards" v-if="!guardado">
      <el-card class="cardEquipo" :data-testid="TEST_ID.GARANTIAS_REGISTRAR.SECTION_DATOS_EQUIPO">
        <div class="grid cardBody">
          <div class="cardTitle gridItem">
            {{ $t("GARANTIAS_datos_equipo") }}
          </div>

          <NumeroSerieInput
            :name="'nro_serie'"
            :label="$t('GARANTIAS_ns_a_registrar')"
            v-model="nro_serie"
            :onChange="this.onNumeroSerieChange"
            :customClases="'nro_serie gridItem'"
            :testIdInput="TEST_ID.GARANTIAS_REGISTRAR.NS_REGISTRAR_INPUT"
            :testIdDescription="TEST_ID.GARANTIAS_REGISTRAR.NS_REGISTRAR_DESCRIPTION"
            @cargaSerieCompleta="cargaSerieCompleta"
          />

          <div class="patente gridItem">
            <div class="patenteContainer">
              <div class="label">{{ $t("GARANTIAS_asociar_elementos") }}</div>
              <el-switch
                :data-testid="TEST_ID.GARANTIAS_REGISTRAR.SWITCH_ASOCIAR_ELEMENTO"
                class="switch"
                v-model="asociarElemento"
                size="small"
              />
            </div>

            <NumeroSerieInput
              v-if="asociarElemento"
              :name="'nro_serie_asoc'"
              :label="$t('GARANTIAS_numero_serie')"
              v-model="nro_serie_asoc"
              :onChange="this.onNumeroSerieChange"
              :customClases="'nro_serie gridItem'"
            />
          </div>

          <div class="fec_instalacion gridItem" :data-testid="TEST_ID.GARANTIAS_REGISTRAR.INPUT_FECHA_INSTALACION">
            <div class="label">{{ $t("GARANTIAS_fecha_instalacion") }}</div>
            <el-date-picker
              v-model="fec_instalacion"
              type="date"
              size="small"
              format="DD/MM/YYYY"
              suffix-icon="Calendar"
            />
          </div>
          <div class="patente gridItem">
            <div class="patenteContainer">
              <div class="label">
                {{
                  tienePatente
                    ? $t("GARANTIAS_patente")
                    : $t("GARANTIAS_marca_modelo")
                }}
              </div>
              <el-switch :data-testid="TEST_ID.GARANTIAS_REGISTRAR.SWITCH_TIENE_PATENTE" class="switch" v-model="tienePatente" size="small" />
            </div>

            <el-input
              :data-testid="TEST_ID.GARANTIAS_REGISTRAR.INPUT_PATENTE_MARCA_MODELO"
              :placeholder="
                tienePatente
                  ? $t('GARANTIAS_nro_patente')
                  : $t('GARANTIAS_marca_modelo_unidad')
              "
              size="small"
              v-model="patente_marcaModelo"
              @blur="formatPatente"
            />
          </div>
        </div>
      </el-card>
      <el-card class="cardUsuario" :data-testid="TEST_ID.GARANTIAS_REGISTRAR.SECTION_DATOS_USUARIO">
        <div class="grid gridUsuario">
          <div class="cardTitle gridItem">
            {{ $t("GARANTIAS_datos_usuario") }}
          </div>
          <div class="nro_serie gridItem">
            <div class="label">{{ $t("GARANTIAS_razon_nombre") }}</div>
            <el-input
              :data-testid="TEST_ID.GARANTIAS_REGISTRAR.INPUT_RAZON_SOCIAL"
              :placeholder="$t('GARANTIAS_razon_nombre')"
              size="small"
              v-model="rz_soc"
            />
          </div>
          <div class="nro_serie_asoc gridItem">
            <div class="label">{{ $t("GARANTIAS_telefono") }}</div>
            <el-input
              :data-testid="TEST_ID.GARANTIAS_REGISTRAR.INPUT_TELEFONO"
              id="prueba"
              :placeholder="$t('GARANTIAS_telefono')"
              size="small"
              v-model="telefono"
              @input="onInput"
            />
          </div>
        </div>
      </el-card>
    </div>

    <div class="container_cards_canje" v-if="!guardado">
      <!-- es canje -->
      <el-card class="cardEquipo" :data-testid="TEST_ID.GARANTIAS_REGISTRAR.SECTION_CANJE">
        <div class="grid cardBody">
          <div class="cardTitle gridItem">
            {{ $t("GARANTIAS_ti_canje") }}
          </div>
          <div class="patenteContainer">
            <div class="label">{{ $t("GARANTIAS_canje") }}</div>
            <el-switch
              :data-testid="TEST_ID.GARANTIAS_REGISTRAR.SWITCH_SOLICITA_CANJE"
              :disabled="habilitaCanje"
              class="switch"
              v-model="solicitaCanje"
              size="small"
            />
          </div>
          <div>
            <div class="nota_canje" >
              <div v-if="!habilitaCanje" v-html="mensajeCanje"></div>
              <div v-else :data-testid="TEST_ID.GARANTIAS_REGISTRAR.TEXT_NO_ES_CANJEABLE">{{ $t("GARANTIAS_noEsCanjeable")  }}</div>
              <!--{{ this.mensajeCanje === '' || habilitaCanje === true ? this.notaCanje : this.mensajeCanje}}-->
            </div>
          </div>
          <div v-if="habilitaCanje === false && solicitaCanje && this.requiereImagen === 'S'">
            <div class="cardTitle_imagen gridItem">Imagenes</div>
            <el-row  :gutter="20">
              <el-col :span="24">
                <div class="label">Imagen 1</div>
                
                <FileUpload
                  name="imagen_1"
                  :limit="1"
                  :accept="',.jpg,.jpeg,.png,.tiff,.raw'"
                  :storeAction="'garantias/uploadImagen'"
                  :files="imagen_1"
                  :temporalId="id_solicitud_1"
                  :numeroArchivo="1"
                  :onFileListChange="imagenChanged"
                  :onFileNameChange="cambiaridImagen"
                  :withBtn="false"
                  :showPreview="true"
                  :garantia="true"
                  style="text-align: left; margin-top: 5px"
                />
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="24">
                <div class="label">Imagen 2</div>
                
                <FileUpload
                  name="imagen_2"
                  :limit="1"
                  :accept="',.jpg,.jpeg,.png,.tiff,.raw'"
                  :files="imagen_2"
                  :storeAction="'garantias/uploadImagen'"
                  :onFileListChange="imagenChanged"
                  :onFileNameChange="cambiaridImagen"
                  :temporalId="id_solicitud_2"
                  :numeroArchivo="2"
                  :withBtn="false"
                  :showPreview="true"
                  :garantia="true"
                  style="text-align: left; margin-top: 5px"
                />
              </el-col>
            </el-row>
          </div>
        </div>
      </el-card>
    </div>

    <div class="btnContainer" v-if="!guardado">
      <el-button :data-testid="TEST_ID.GARANTIAS_REGISTRAR.BUTTON_GUARDAR" type="primary" @click="nuevaGarantia" :loading="loading">{{
        $t("GENERAL_saveBtn")
      }}</el-button>
      <router-link :to="{ name: 'Garantias', query: { keepFilter: 'true' } }">
        <el-button :data-testid="TEST_ID.GARANTIAS_REGISTRAR.BUTTON_CANCELAR">{{ $t("GENERAL_cancelBtn") }}</el-button>
      </router-link>
    </div>

    <!-- Secci�n datos guardados con exito -->
    <el-row :gutter="20" v-if="guardado" style="margin-top: 20px;">
      <el-col :span="24">
        <el-row>
          <el-col :span="19">
            <div class="title">{{ $t("GARANTIAS_registro_exito") }}</div>
          </el-col>
          <el-col :span="4">
            <el-button
              @click="onNuevaGarantia"
              type="primary"
              icon="Plus"
              size="default"
              round
              >{{ $t("GENERAL_nuevo") }}</el-button
            >
          </el-col>
        </el-row>
        <el-row>
          <div>
            <el-card class="cardGuardado">
              <div class="cardTitle" style="margin-bottom: 10px">
                {{ $t("GARANTIAS_datos_equipo") }}
              </div>
              <el-row>
                <el-row :gutter="20">
                  <el-col :xs="24" :sm="7" :md="7" :lg="7" :xl="7">
                    <div class="greyLabel">
                      {{ $t("GARANTIAS_numero_serie") }}:
                    </div>
                  </el-col>
                  <el-col :xs="24" :sm="17" :md="17" :lg="17" :xl="17">
                    <div class="blackLabel">{{ this.nro_serie }}</div>
                  </el-col>
                </el-row>

                <el-row :gutter="20">
                  <el-col :xs="24" :sm="7" :md="7" :lg="7" :xl="7">
                    <div class="greyLabel">{{ $t("GARANTIAS_ns_asoc") }}</div>
                  </el-col>
                  <el-col :xs="24" :sm="17" :md="17" :lg="17" :xl="17">
                    <div class="blackLabel">{{ this.nro_serie_asoc }}</div>
                  </el-col>
                </el-row>

                <el-row :gutter="20">
                  <el-col :xs="24" :sm="7" :md="7" :lg="7" :xl="7">
                    <div class="greyLabel">
                      {{ $t("GARANTIAS_fecha_instalacion") }}:
                    </div>
                  </el-col>
                  <el-col :xs="24" :sm="17" :md="17" :lg="17" :xl="17">
                    <div class="blackLabel">
                      {{ this.fec_instalacion.toLocaleDateString() }}
                    </div>
                  </el-col>
                </el-row>

                <el-row :gutter="20">
                  <el-col :xs="24" :sm="7" :md="7" :lg="7" :xl="7">
                    <div class="greyLabel">
                      {{
                        tienePatente
                          ? $t("GARANTIAS_patente")
                          : $t("GARANTIAS_marca_moddelo")
                      }}
                    </div>
                  </el-col>
                  <el-col :xs="24" :sm="17" :md="17" :lg="17" :xl="17">
                    <div class="blackLabel">{{ this.patente_marcaModelo }}</div>
                  </el-col>
                </el-row>
              </el-row>
              <hr />
              <div class="cardTitle" style="margin-bottom: 10px">
                {{ $t("GARANTIAS_datos_usuario") }}
              </div>
              <el-row>
                <el-row :gutter="20">
                  <el-col :xs="24" :sm="7" :md="7" :lg="7" :xl="7">
                    <div class="greyLabel">
                      {{ $t("GARANTIAS_razon_nombre") }}:
                    </div>
                  </el-col>
                  <el-col :xs="24" :sm="7" :md="7" :lg="7" :xl="7">
                    <div class="blackLabel">{{ this.rz_soc }}</div>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :xs="24" :sm="7" :md="7" :lg="7" :xl="7">
                    <div class="greyLabel">{{ $t("GARANTIAS_telefono") }}:</div>
                  </el-col>
                  <el-col :xs="24" :sm="7" :md="7" :lg="7" :xl="7">
                    <div class="blackLabel">{{ this.telefono }}</div>
                  </el-col>
                </el-row>
                </el-row>
                <hr />
              <div class="cardTitle" style="margin-bottom: 10px">
                {{ $t("GARANTIAS_ti_canje") }}
              </div>
              <el-row>
                <el-row :gutter="20">
                  <el-col :xs="24" :sm="7" :md="7" :lg="7" :xl="7">
                    <div class="greyLabel">
                      {{ $t("GARANTIAS_canje") }}:
                    </div>
                  </el-col>
                  <el-col :xs="24" :sm="7" :md="7" :lg="7" :xl="7">
                    <div class="blackLabel">{{ this.solicitaCanje? "SI":"NO" }}</div>
                  </el-col>
                </el-row>
              </el-row>
            </el-card>
          </div>
        </el-row>
        <el-row>
          <div>
            <el-button disabled="true">{{ $t("GENERAL_editBtn") }}</el-button>
            <router-link
              :to="{
                name: 'Garantias',
                query: { keepFilter: 'true', ns: this.nro_serie },
              }"
            >
              <el-button type="primary">{{
                $t("GENERAL_acceptBtn")
              }}</el-button>
            </router-link>
          </div>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapState } from "vuex";
import NumeroSerieInput from "../NumeroSerieInput";
import {
  mostrarMensajeInternacionalizado,
} from "../MensajeInternacionalizado";
import { showError } from "../Mensaje";
import FileUpload from "@/components/FileUpload";
import TEST_ID from "@/testIds.json";

export default {
  name: "AltaGarantia",
  components: { NumeroSerieInput, FileUpload },
  data() {
    return {
      TEST_ID,
      nro_serie: "",
      nro_serie_valido: false,
      nro_serie_asoc: "",
      nro_serie_asoc_valido: false,
      patente_marcaModelo: "",
      fec_instalacion: new Date(),
      rz_soc: "",
      telefono: "",
      tienePatente: true,
      old_telefono: "",
      guardado: false,
      loading: false,
      asociarElemento: false,
      habilitaCanje: true,
      solicitaCanje: false,
      datosUsuario: {},
      mensajeCanje: "",
      requiereImagen: "N",
      notaCanje: "No es Canjeable",
      obs_img_1: "",
      obs_img_2: "",
      imagen_1: [],
      imagen_2: [],
      id_solicitud_1: "",
      id_solicitud_2: "",
    };
  },
  mounted() {
    this.getDatosUsuario();
  },
  watch: {
    tienePatente() {
      this.patente_marcaModelo = "";
    },
  },
  methods: {
    getDatosUsuario() {
      this.$store
        .dispatch("sesion/getDatosUsuario", this.idUsuario)
        .then((data) => {
          this.datosUsuario = data;
        });
    },
    cargaSerieCompleta(value) {
      if (value) {
        let payload = {
          p_NS: value.toString(),
          p_Clild: parseFloat(this.datosUsuario.Id),
        };
        this.$store
          .dispatch("solicitudes/getEsCanjeable", payload)
          .then((data) => {
            if (data) {
              console.log(data)
              if (data.EsCanjeable === "S") {
                this.habilitaCanje = false;
                this.mensajeCanje = this.formatMensaje(data.MensajeCanjeable);
                this.requiereImagen = data.RequiereImagen;
              } else {
                this.habilitaCanje = true;
              }
            }
          });
      }
    },
    formatMensaje(value){
      if(!value) return '';

      let formatted = value
      .replace(/\*([^*]+)/g, '� $1<br>') // Reemplazar asteriscos por vi�etas y a�adir saltos de l�nea
      .replace(/\n/g, '<br>'); // Asegurarse de que los saltos de l�nea se respeten
      return formatted;
    },
    onInput() {
      var regExp = /^(\(*[0-9]*\)*-*[0-9]*)*$/;
      var matches = regExp.exec(this.telefono);

      if (!matches) {
        this.telefono = this.old_telefono;
      } else this.old_telefono = this.telefono;
    },
    formatPatente() {
      if (this.tienePatente)
        this.patente_marcaModelo = this.patente_marcaModelo.split(" ").join("");
    },
    onNumeroSerieChange(payload) {
      this[payload.name] = payload.value;
      this[payload.name + "_valido"] = payload.valid;
    },
    nuevaGarantia() {
      this.loading = true;

      // valido la garant�a
      if (!this.validate()) {
        this.loading = false;
        return;
      }

      // armo el payload
      let payload = {};
      payload.id_Usuario = this.idUsuario;
      payload.ns = this.nro_serie;
      payload.fecha_install = this.fec_instalacion;
      payload.razon_social = this.rz_soc;
      payload.telefono = this.telefono;
      payload.pat_motor =
        this.tienePatente === true ? this.patente_marcaModelo : "";
      payload.marca_modelo =
        this.tienePatente === false ? this.patente_marcaModelo : "";
      payload.ns_asociado = this.nro_serie_asoc;
      payload.solicitaCanje = this.solicitaCanje ? "S" : "N";
      payload.imagenes = [];

      if (this.imagen_1 !== undefined && this.imagen_1.length > 0)
        payload.imagenes.push({
          nombre_archivo: this.getNombreArchivo(this.imagen_1[0].name, 1)
        });

      if (this.imagen_2 !== undefined && this.imagen_2.length > 0)
        payload.imagenes.push({
          nombre_archivo: this.getNombreArchivo(this.imagen_2[0].name, 2)
        });

      // guardo la garant�a
      this.$store
        .dispatch("garantias/altaGarantia", payload)
        .then((data) => {
          // �xito
          if (data.CodigoResultado === 0) {
            //showSuccess(this.$t('GENERAL_success'))
            this.guardado = true;
            //this.$router.push({ name: 'Garantias', query: { keepFilter: 'true' } })
          }
          // error
          else
            mostrarMensajeInternacionalizado(
              data.CodigoResultado,
              data.DescripcionResultado
            );
        })
        .finally(() => (this.loading = false));
    },
     getNombreArchivo(nombreOriginal, numeroArchivo) {
      // armo el nombre del archivo (ejemplo Id_solic_servicio + �_�+_numero_archivo.jpg)
      let numeroSolicitud = nombreOriginal.split(".")[0];
      let extensionArchivo = nombreOriginal.split(".").pop();

      return `${numeroSolicitud}_${numeroArchivo}.${extensionArchivo}`;
    },
    onNuevaGarantia() {
      this.$router.go();
    },
    validate() {
      let valida = true;

      if (!this.nro_serie || !this.nro_serie_valido) {
        showError(this.$t("GENERAL_missing_nro_serie"));
        valida = false;
      }

      if (this.nro_serie_asoc && !this.nro_serie_asoc_valido) {
        showError(this.$t("GENERAL_missing_nro_serie_asoc"));
        valida = false;
      }

      if (!this.fec_instalacion) {
        showError(this.$t("GENERAL_missing_fec_instalcion"));
        valida = false;
      }

      if (!this.patente_marcaModelo) {
        let mensaje =
          this.tienePatente === true
            ? this.$t("GENERAL_missing_patente")
            : this.$t("GENERAL_missing_marca_modelo");
        showError(mensaje);
        valida = false;
      }

      if (!this.rz_soc) {
        showError(this.$t("GENERAL_missing_rz_soc"));
        valida = false;
      }

      if (!this.telefono) {
        showError(this.$t("GENERAL_missing_telefono"));
        valida = false;
      }

      if ( this.solicitaCanje && this.requiereImagen ==='S') {
        if (!(this.imagen_1 !== undefined && this.imagen_1.length > 0) || !(this.imagen_2 !== undefined && this.imagen_2.length > 0)) {
          showError(this.$t("GENERAL_missing_imagen_garantia"));
          valida = false;
        }
      }

      return valida;
    },
    
     imagenChanged(name, fileList) {
      switch (name) {
        case "imagen_1":
          this.imagen_1 = fileList;
          break;
        case "imagen_2":
          this.imagen_2 = fileList;
          break;
      }
    },
  },
  computed: mapState({
    idUsuario: (state) => state.sesion.resultadoAutenticacion.IdUsuario,
  }),
};
</script>

<style scoped>
.container_card_guardado {
  display: flex;
  text-align: center !important;
  align-items: center;
}
.cardGuardado {
  text-align: center !important;
  max-width: 90% !important;
  margin-left: 10px !important;
  margin-right: 10px !important;
  margin-bottom: 10px;
}
.cardBody {
  padding-left: 25px;
}

.greyLabel {
  font-size: 14px;
  color: #6b6b6b;
  text-align: left;
  font-weight: normal;
}
.blackLabel {
  font-size: 14px;
  color: black;
  text-align: left;
  font-weight: bold;
}
.container {
  padding: 0 30px;
  max-width: 800px;
  margin: 0 auto;
}

@media (max-width: 600px) {
  .container {
    padding: 10px 0px;
  }
}
.title {
  font-size: 24px;
  font-weight: bold;
  text-align: left;
  color: var(--main-color);
  margin-bottom: 20px;
}
@media (max-width: 800px) {
  .title {
    text-align: center;
  }
}
.container_cards {
  display: flex;
}

.nota_canje {
  margin-top: 10px;
  text-align: left !important;
}

.container_cards_canje {
  margin-top: 10px;
  display: flex;
}
.cardEquipo {
  flex: 50%;
}
.cardUsuario {
  flex: 50%;
  margin-left: 20px;
}

@media (max-width: 1000px) {
  .container_cards {
    flex-direction: column;
  }
  .cardUsuario {
    flex: 50%;
    margin-top: 20px;
    margin-left: 0;
  }
}
.cardTitle_imagen {
  font-size: 14px;
  font-weight: 600;
  text-align: left;
  color: black;
  margin-top: 15px;
}
.cardTitle {
  font-size: 18px;
  font-weight: 600;
  text-align: left;
  color: black;
}
.label {
  text-align: left;
  margin-top: 15px;
  margin-bottom: 4px;
  font-size: 14px;
}
.labelBold {
  margin-top: 10px;
  text-align: left;
  font-size: 15px;
  font-weight: bold;
}
.labelGuardado {
  margin-top: 10px;
  margin-left: 2px;
  text-align: left;
  font-size: 14px;
}
.switch {
  float: right;
  margin-top: 20px;
}
.fec_instalacion {
  grid-column-start: 2;
  grid-row-start: 2;
}
.patente {
  grid-column-start: 3;
  grid-row-start: 2;
}
.labelError {
  margin-top: 15px;
}
.error {
  color: #f56c6c;
}
.success {
  color: #67c23a;
}
.btnContainer {
  margin-top: 10px;
  /* white-space: nowrap; */
}
.grid,
.gridUsuario {
  display: flex;
  flex-direction: column;
  padding: 20px 0px;
}
.gridUsuario {
  grid-template-rows: 1fr 1fr;
}

.fec_instalacion {
  grid-column-start: 2;
  grid-row-start: 3;
}
.patente {
  grid-column-start: 2;
  grid-row-start: 4;
}

.patenteContainer {
  display: inline-flex;
  width: 100%;
}
.patenteContainer .label {
  float: left;
  width: calc(100% - 40px);
}
.patenteContainer .switch {
  margin-top: 12px;
}

@media (max-width: 900px) {
  .grid,
  .gridUsuario {
    display: flex;
    flex-direction: column;
  }
  .gridItem {
    flex: 1;
    padding: 8px;
  }
}
.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: -webkit-fill-available;
}

.descripcion {
  text-align: left;
  font-size: 12px;
  margin-top: 10px;
  color: #666;
}
.descripcion.invalido {
  color: #f44336;
}

.guardado {
  width: 50%;
}
.container_cards {
  display: flex;
}
</style>

<style>
.altaGarantia .nro_serie_asoc {
  grid-column-start: 2;
  grid-row-start: 2;
}

@media (max-width: 900px) {
  .altaGarantia .gridItem {
    flex: 1;
    padding: 8px;
  }
}
</style>